/** @format */

import { HeaderCheckBoxSelectListElement } from '../lib/search/listTableHeader/HeaderCheckBoxSelectList';

/** @format */

const _ = require('underscore');

export const MnpEventTypeMapInt = {
    E13IN: 1,
    E13OUT: 2,
    E14RETURN: 3,
    E14OUT: 4,
};

export const MnpEventTypeMapI18n = {
    E13IN: 'mnp_cases:state.port_in',
    E13OUT: 'mnp_cases:state.port_out',
    E14RETURN: 'mnp_cases:state.number_return',
    E14OUT: 'mnp_cases:state.number_out',
};

export class MnpEventType {
    getEventTypes = (): Array<HeaderCheckBoxSelectListElement> => {
        return [
            { value: MnpEventTypeMapInt.E13IN, name: MnpEventTypeMapI18n.E13IN },
            { value: MnpEventTypeMapInt.E13OUT, name: MnpEventTypeMapI18n.E13OUT },
            { value: MnpEventTypeMapInt.E14RETURN, name: MnpEventTypeMapI18n.E14RETURN },
            { value: MnpEventTypeMapInt.E14OUT, name: MnpEventTypeMapI18n.E14OUT },
        ];
    };

    getI18Name = (eventType: string, donor: boolean): string => {
        switch (eventType) {
            case 'E13':
                if (donor) {
                    return MnpEventTypeMapI18n.E13OUT;
                }
                return MnpEventTypeMapI18n.E13IN;
            case 'E14':
                if (donor) {
                    return MnpEventTypeMapI18n.E14OUT;
                }
                return MnpEventTypeMapI18n.E14RETURN;
            default:
                return '';
        }
    };
}
